import axios from 'axios'
import route from '../ziggy/route'

export default {
    add(address) {
        return axios.post(route('shop.addresses.store').url(), address)
    },

    delete(address) {
        return axios.delete(route('shop.addresses.destroy', address.id).url())
    }
}
